import { Button, DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierPlan extends Layout {
    buttonAddActivity: Button;
    sourceCarrierPlan: DataSource;
    sourceCarrierPlanDetail: DataSource;
    tableCarrierPlanDetail: Table;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
